import { SERVICE_ITEM_STATES, getStateNameById } from "./chunk-LW3YLJTS.js";

// src/services.ts
var SERVICES = {
  FILE_DESIGN: "File Design",
  FILE_CHANGE: "File Change",
  FILE_CHECK: "File Check"
};
var SERVICES_WITHOUT_USER_ARTWORK = [SERVICES.FILE_DESIGN, SERVICES.FILE_CHANGE];
var getServices = orderOrCart => {
  const {
    customLineItems
  } = orderOrCart;
  if (customLineItems && customLineItems.length > 0) {
    const services = customLineItems.filter(customLineItem => {
      var _a;
      return ((_a = customLineItem.custom) == null ? void 0 : _a.fields.lineItemType) === "service";
    });
    return services;
  }
  return [];
};
var getLinkedServices = (lineItemId, orderOrCart) => {
  const services = getServices(orderOrCart);
  const linkedServices = services.filter(service => service.custom.fields.lineItemReference === lineItemId);
  return linkedServices;
};
var hasLinkedServices = (lineItemId, orderOrCart) => {
  const linkedServices = getLinkedServices(lineItemId, orderOrCart);
  return Boolean(linkedServices.length > 0);
};
var getServiceStateName = (service, env) => {
  const [state] = service.state;
  if (service.state.length === 0) {
    return null;
  }
  return getStateNameById(env, state.state.id);
};
var getServiceName = service => service.custom.fields.serviceName;
var isService = lineItem => {
  var _a;
  return ((_a = lineItem.custom) == null ? void 0 : _a.fields.lineItemType) === "service";
};
var getLinkedServiceNames = (lineItemId, orderOrCart) => {
  const services = getLinkedServices(lineItemId, orderOrCart);
  const serviceNames = services.map(service => getServiceName(service));
  return serviceNames;
};
var getLinkedArtworkServices = (lineItemId, orderOrCart) => {
  const VALID_ARTWORK_SERVICES = [SERVICES.FILE_DESIGN, SERVICES.FILE_CHANGE, SERVICES.FILE_CHECK];
  const linkedServices = getLinkedServices(lineItemId, orderOrCart);
  const linkedArtworkServices = linkedServices.reduce((serviceLineItems, serviceLineItem) => {
    const linkedServiceName = getServiceName(serviceLineItem);
    if (!VALID_ARTWORK_SERVICES.includes(linkedServiceName)) {
      return serviceLineItems;
    }
    serviceLineItems.push(serviceLineItem);
    return serviceLineItems;
  }, []);
  return linkedArtworkServices;
};
var getActiveArtworkServices = (lineItemId, orderOrCart, env) => {
  const linkedArtworkServices = getLinkedArtworkServices(lineItemId, orderOrCart);
  if (linkedArtworkServices.length > 0) {
    return linkedArtworkServices.filter(artworkService => getServiceStateName(artworkService, env) !== SERVICE_ITEM_STATES.CANCELLED);
  }
  return [];
};
var hasActiveArtworkServiceOfTypes = (lineItemId, orderOrCart, serviceNames, environment) => {
  const activeArtworkServices = getActiveArtworkServices(lineItemId, orderOrCart, environment);
  return activeArtworkServices.some(service => serviceNames.includes(getServiceName(service)));
};
var hasActiveArtworkServices = (lineItemId, orderOrCart, enviroment) => Boolean(getActiveArtworkServices(lineItemId, orderOrCart, enviroment).length > 0);
export { SERVICES, SERVICES_WITHOUT_USER_ARTWORK, getServices, getLinkedServices, hasLinkedServices, getServiceStateName, getServiceName, isService, getLinkedServiceNames, getLinkedArtworkServices, getActiveArtworkServices, hasActiveArtworkServiceOfTypes, hasActiveArtworkServices };